import { render, staticRenderFns } from "./SearchDate.vue?vue&type=template&id=bd84707a&scoped=true"
import script from "./SearchDate.vue?vue&type=script&lang=js"
export * from "./SearchDate.vue?vue&type=script&lang=js"
import style0 from "./SearchDate.vue?vue&type=style&index=0&id=bd84707a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd84707a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd84707a')) {
      api.createRecord('bd84707a', component.options)
    } else {
      api.reload('bd84707a', component.options)
    }
    module.hot.accept("./SearchDate.vue?vue&type=template&id=bd84707a&scoped=true", function () {
      api.rerender('bd84707a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/SearchDate.vue"
export default component.exports